export default __webpack_public_path__ + "static/media/JBT.12859a3c.png";